import React, { useEffect, useState } from 'react';
import useStyles from 'apps/Pdf/components/common/styles/PdfContent';
import { PdfTheme } from 'apps/Pdf/components/PdfTheme';
import { ApiResponseError } from 'stores/apiStore';
import { logError } from 'apps/Pdf/helpers/helpers';

interface Props {
  className?: string;
  errors?: ApiResponseError[];
  onload?: boolean; // show pdfContainer after page load
  afterLoad?: () => void;
  empty?: boolean;
}

const pdfContainerId = 'pdf-container';

const PdfContent: React.FC<Props> = ({ className, errors, onload, children, afterLoad, empty }) => {
  const classes = useStyles();
  const [loaded, setLoaded] = useState(false);
  if (errors && errors.length) {
    logError(errors[0].key, errors[0].message);
  }

  useEffect(() => {
    if (window) {
      const loaded = document.readyState === 'complete';
      if (loaded) {
        setLoaded(true);
        afterLoad !== undefined && afterLoad();
      } else {
        window.onload = () => {
          setLoaded(true);
          afterLoad !== undefined && afterLoad();
        }
      }
    }
  }, [afterLoad]);

  return errors ? (
    <div className={classes.root} id={pdfContainerId} />
  ) : (
    <PdfTheme>
      <div
        className={`${classes.root}${empty ? ' ' + classes.empty : ''}${className ? ' ' + className : ''} _PDF_content`}
        id={!onload ? pdfContainerId : undefined}
      >
        {children}
      </div>
      {loaded && onload && <div id={pdfContainerId} />}
    </PdfTheme>
  );
};

export default PdfContent;
